// src/authConfig.js
import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "fa2b186c-8cb0-4397-9222-c9f51900416c", // App (client) ID
    authority: "https://login.microsoftonline.com/296d57f6-1f2b-498b-986e-ad87f225b576", // Tenant ID
    redirectUri: "https://alpha.uatlantica.pt",
    postLogoutRedirectUri: "https://alpha.uatlantica.pt",
  },
  cache: {
    cacheLocation: "localStorage", // mantém sessão ao fechar o browser
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        if (level === LogLevel.Warning) console.warn(message);
        if (level === LogLevel.Info) console.info(message);
        if (level === LogLevel.Verbose) console.debug(message);
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"], // suficiente para obter info do utilizador
};
